module.exports = __webpack_public_path__ + "img/8.b5ed9745.jpg";